import { useThemeStore } from '@/store/themeStore';
import { useEffect, useState } from 'react';

export const useThemeHydration = () => {
  const [isHydrated, setIsHydrated] = useState(useThemeStore.persist.hasHydrated());

  useEffect(() => {
    if (useThemeStore.persist.hasHydrated()) {
      useThemeStore.getState().setHasHydrated(true);
      setIsHydrated(true);
      return;
    }

    const unsubHydrate = useThemeStore.persist.onFinishHydration(() => {
      useThemeStore.getState().setHasHydrated(true);
      setIsHydrated(true);
    });

    void useThemeStore.persist.rehydrate();

    return () => {
      unsubHydrate();
    };
  }, []);

  return isHydrated;
};
